/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetPlannedCargoActionsPerCharterQueryVariables = Types.Exact<{
  search: Types.PlannedCargoActionsSearch;
  pagination: Types.Pagination;
}>;


export type GetPlannedCargoActionsPerCharterQuery = {
  __typename?: 'Query',
  plannedCargoActionsPerCharter: {
    __typename?: 'LocationCharterCargoActionPage',
    totalElements: number,
    content: Array<{
      __typename?: 'LocationCharterCargoAction',
      locationWithGroup: {
        __typename?: 'LocationWithGroup',
        location: {
          __typename?: 'Location',
          id: number,
          description: string,
          lastTerminalContactDate?: number | null
        },
        locationGroup?: {
          __typename?: 'Location',
          id: number,
          description: string
        } | null
      },
      charterCargoActions: Array<{
        __typename?: 'CharterCargoAction',
        charter: {
          __typename?: 'PurchaseCharter',
          id: number,
          charterNumber: string,
          type: Types.CharterType,
          debtor: {
            __typename?: 'Relation',
            id: number,
            name: string
          }
        } | {
          __typename?: 'SalesCharter',
          id: number,
          charterNumber: string,
          type: Types.CharterType,
          debtor: {
            __typename?: 'Relation',
            id: number,
            name: string
          }
        },
        cargoActions: Array<{
          __typename?: 'CargoAction',
          id: number,
          type: Types.CallType,
          reference?: string | null,
          terminalPlanningNotes?: string | null,
          weight?: number | null,
          volume?: number | null,
          start?: number | null,
          end?: number | null,
          displayAsWindow?: boolean | null,
          simulatedTimestamp?: boolean | null,
          location?: {
            __typename?: 'Location',
            id: number,
            description: string
          } | null,
          call?: {
            __typename?: 'Call',
            id: number,
            pta?: number | null,
            voyage: {
              __typename?: 'Voyage',
              id: number,
              voyageNumber: string,
              ship: {
                __typename?: 'Ship',
                id: number,
                name: string
              }
            }
          } | null,
          connectingShipPortVisit?: {
            __typename?: 'ConnectingShipPortVisit',
            id: number,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string
            }
          } | null,
          cargo: {
            __typename?: 'Cargo',
            id: number,
            cargoNumber?: string | null,
            containerNumber?: string | null,
            product?: {
              __typename?: 'Product',
              id: number,
              name: string
            } | null,
            actions: Array<{
              __typename?: 'CargoAction',
              type: Types.CallType
            }>,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>
          },
          measurements: {
            __typename?: 'Measurements',
            locationWeight?: number | null,
            locationWeightUnit?: Types.WeightUnit | null
          },
          firstCorrespondingLoadingAction?: {
            __typename?: 'CargoAction',
            id: number,
            shipToShip?: boolean | null,
            connectingVisitNotes?: string | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              locationGroups: Array<{
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType
              }>
            } | null,
            connectingShipPortVisit?: {
              __typename?: 'ConnectingShipPortVisit',
              id: number,
              from?: number | null,
              until?: number | null,
              lastUpdateFromAgentOn?: number | null,
              location: {
                __typename?: 'Location',
                id: number,
                description: string
              },
              agent?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              ship: {
                __typename?: 'Ship',
                id: number,
                name: string,
                bargeType?: Types.BargeType | null,
                mmsi?: number | null,
                eni?: string | null,
                planningNotes?: string | null,
                tanks: Array<{
                  __typename?: 'Tank',
                  id: number,
                  positionNumber: number
                }>
              }
            } | null,
            connectingShipBerthing?: {
              __typename?: 'ConnectingShipBerthing',
              id?: number | null,
              window?: {
                __typename?: 'TimeWindow',
                from?: number | null,
                to?: number | null
              } | null,
              location?: {
                __typename?: 'Location',
                id: number,
                description: string,
                locationGroups: Array<{
                  __typename?: 'Location',
                  id: number,
                  description: string,
                  type: Types.LocationType
                }>
              } | null
            } | null
          } | null,
          lastCorrespondingDischargingAction?: {
            __typename?: 'CargoAction',
            id: number,
            shipToShip?: boolean | null,
            connectingVisitNotes?: string | null,
            location?: {
              __typename?: 'Location',
              id: number,
              description: string,
              locationGroups: Array<{
                __typename?: 'Location',
                id: number,
                description: string,
                type: Types.LocationType
              }>
            } | null,
            connectingShipPortVisit?: {
              __typename?: 'ConnectingShipPortVisit',
              id: number,
              from?: number | null,
              until?: number | null,
              lastUpdateFromAgentOn?: number | null,
              location: {
                __typename?: 'Location',
                id: number,
                description: string
              },
              agent?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              ship: {
                __typename?: 'Ship',
                id: number,
                name: string,
                bargeType?: Types.BargeType | null,
                mmsi?: number | null,
                eni?: string | null,
                planningNotes?: string | null,
                tanks: Array<{
                  __typename?: 'Tank',
                  id: number,
                  positionNumber: number
                }>
              }
            } | null,
            connectingShipBerthing?: {
              __typename?: 'ConnectingShipBerthing',
              id?: number | null,
              window?: {
                __typename?: 'TimeWindow',
                from?: number | null,
                to?: number | null
              } | null,
              location?: {
                __typename?: 'Location',
                id: number,
                description: string,
                locationGroups: Array<{
                  __typename?: 'Location',
                  id: number,
                  description: string,
                  type: Types.LocationType
                }>
              } | null
            } | null
          } | null,
          connectingShipBerthing?: {
            __typename?: 'ConnectingShipBerthing',
            id?: number | null
          } | null
        }>
      }>
    }>
  }
};


export const GetPlannedCargoActionsPerCharterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlannedCargoActionsPerCharter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlannedCargoActionsSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plannedCargoActionsPerCharter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWithGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastTerminalContactDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"charterCargoActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"terminalPlanningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstCorrespondingLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastCorrespondingDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitNotes"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<GetPlannedCargoActionsPerCharterQuery, GetPlannedCargoActionsPerCharterQueryVariables>;